(function () {
  'use strict';

  const SUCCESS_DISPLAY_TIME = 5000;

  function setupFormsWatcher(formsEmbed) {
    if (!formsEmbed || !formsEmbed.shadowRoot) {
      return;
    }

    const appEmbed = formsEmbed.shadowRoot.querySelector('#app-embed');

    if (!appEmbed) {
      return;
    }

    let successHandled = false;
    let observer = null;

    const checkState = function () {
      const currentStep = appEmbed.getAttribute('data-current-step');

      if (currentStep === 'success' && !successHandled) {
        successHandled = true;

        /*
         * We don't need to observe Forms anymore.
         */
        if (observer) {
          observer.disconnect();
        }

        setTimeout(function () {
          /*
           * Hide the entire Shopify Forms component.
           * We don't modify anything inside its Shadow DOM.
           */
          formsEmbed.style.display = 'none';
        }, SUCCESS_DISPLAY_TIME);
      }
    };

    /*
     * Check the current state once.
     */
    checkState();

    /*
     * Watch ONLY data-current-step.
     */
    observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-current-step'
        ) {
          checkState();
          break;
        }
      }
    });

    observer.observe(appEmbed, {
      attributes: true,
      attributeFilter: ['data-current-step']
    });
  }

  function findForms() {
    const formsEmbed = document.querySelector('shopify-forms-embed');

    if (!formsEmbed) {
      return false;
    }

    if (!formsEmbed.shadowRoot) {
      return false;
    }

    const appEmbed = formsEmbed.shadowRoot.querySelector('#app-embed');

    if (!appEmbed) {
      return false;
    }

    setupFormsWatcher(formsEmbed);

    return true;
  }

  /*
   * Shopify Forms may load after the theme.
   */
  if (!findForms()) {
    const observer = new MutationObserver(function () {
      if (findForms()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();